import { toJS } from 'mobx'
import { useEffect, useState } from 'react'

import { DeleteModal } from '@/Core/Features/UI/CrudResource/components'
import { deleteConfirmTextFor } from '@/Ship/Helpers/deleteConfirmText'

import { DICTIONARY_DELETE_EVENT } from './events'

/**
 * Підтвердження й видалення запису з картки довідника. Видаляє стандартна дія ядра
 * (actions.delete: запит, тост, захист від подвійного кліку); після успіху картка
 * закривається, а список за нею перечитується без кешу.
 */
export const DictionaryDeleteAction = ({ crudContext }: any) => {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const eventManager = crudContext?.eventManager
        if (!eventManager) return undefined

        eventManager.on(DICTIONARY_DELETE_EVENT, 'openDictionaryDelete', () => setOpen(true))
        eventManager.on('onAfterDeleteRequest', 'closeDictionaryCard', () => {
            // load(true): reload() списку взяв би його з 30-секундного кешу GET — запис лишився б
            crudContext?.listCrudContext?.listContext?.actions?.load?.(true)
            // Закриття як хрестиком: drawer, onClose і крок назад в історії (ResourceDetail)
            if (typeof crudContext?.closeResourceDetail === 'function') crudContext.closeResourceDetail()
            else crudContext?.drawerContext?.setIsOpen?.(false)
        })

        return () => {
            eventManager.off(DICTIONARY_DELETE_EVENT, 'openDictionaryDelete')
            eventManager.off('onAfterDeleteRequest', 'closeDictionaryCard')
        }
    }, [crudContext])

    const values = toJS(crudContext?.formContext?.values ?? {})
    const description = deleteConfirmTextFor(crudContext, values)

    return (
        <DeleteModal
            open={open}
            {...(description ? { description } : {})}
            onCancel={() => setOpen(false)}
            onConfirm={() => {
                setOpen(false)
                crudContext?.actions?.delete?.(values)
            }}
        />
    )
}
